import useContactPatientQualification from "../../../UseContactPatientQualification";

/** A quick component wrapper to mount the legacy {@link useContactPatientQualification} hook. */
const AppContextUseContactPatientQualification: React.FC = () => {
  useContactPatientQualification();
  return null;
};

export default AppContextUseContactPatientQualification;
